<div class="body-categoria py-5 px-2">
    <div class="box-content mx-auto mw-100">
        <p class="text-center fs-5">Seleccione las categorias a descargar</p>
        <mat-spinner *ngIf="categorias.cargando" class="d-block mx-auto mb-5" diameter="20"></mat-spinner>

        <mat-list>
        <mat-list-item *ngFor="let categoria of categorias.registros">
          
            <label>
                <input class="categoria" 
                [(ngModel)]="categoriasSeleccionadas[categoria.categoryid]" type="checkbox" 
                (change)="toggleCategoriaSeleccionada(categoria.categoryid)"
                />{{ categoria.categorydescription }}
            </label>
        </mat-list-item>
        </mat-list>
       
    </div>
    
    <mat-spinner *ngIf="cargando" class="d-block mx-auto my-3" diameter="20"></mat-spinner>
    <mat-dialog-actions align="center">


        <button mat-raised-button color="accent" (click)="descargar()">Descargar</button>
        <button mat-raised-button color="warn" mat-dialog-close>Cerrar</button>
    </mat-dialog-actions>
</div>